import React from "react";
import styled from "styled-components";
import Label from "./Label";

const Labels = (props) => {
  const { labels } = props;
  return (
    <Container>
      {labels.map(
        (label, i) =>
          label != false && label && label != undefined && <Label data={label} key={"label" + i} />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 4px;
  align-self: stretch;
  flex-wrap: wrap;
`;

export default Labels;
